import MetricsUsage from '@/metrics/views/usage/Index.vue';

const routes = [
  {
    path: '/my-account/metrics/usage/',
    name: 'Metrics-Usage',
    component: MetricsUsage,
  },
];

export default routes;
